import React, { useEffect, useState } from 'react'
import { Panel } from 'primereact/panel'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import './ImportMotoristaMassa.css'
import {
  PageHeader,
  Btn,
  TextBtn,
  ExcelModeloBuilder,
  ImportExcelFile,
  CustomCheckbox,
} from '../../../../components'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import { saveDriversMassively } from '../../../../services/api/https/system/system.http'
import CnpjCpf from '../../../../components/CnpjCpf/CnpjCpf'
import { formatDateToLocale, formatIsoDateToLocale } from '../../../../services/util/date.service'

const ImportMotoristaMassa = ({ selectedTp, history, dispatch }) => {
  const modeloExcel = [
    [
      'nome (string)*',
      'numero_cnh (int)',
      'tipo_cnh (string)',
      'data_expiracao_cnh (dd/mm/yyyy)',
      'telefone_contato (int)',
      'endereco (string)',
      'data_expiracao_toxocologico (dd/mm/yyyy)',
      'ativo (0,1)*',
      'cpf (int)',
    ],
  ]

  const [motoristas, setMotoristas] = useState([])

  const onBtnSalvarClicked = async () => {
    dispatch(showLoadingBox('Aguarde...', 'Carregando...'))
    try {
      if (selectedTp === '') {
        throw new Error('Selecione um TP')
      }
      if (motoristas.length === 0) {
        throw new Error('Não existem Motoristas para Importação')
      }
      const message = await saveDriversMassively(motoristas)
      dispatch(showMessageBox(message, null))
      setMotoristas([])
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  const onBtnVoltarClicked = () => {
    history.goBack()
  }

  const _planilhaNoPadrao = content => {
    const header = content[0]
    return (
      header[0] === 'nome (string)*' &&
      header[1] === 'numero_cnh (int)' &&
      header[2] === 'tipo_cnh (string)' &&
      header[3] === 'data_expiracao_cnh (dd/mm/yyyy)' &&
      header[4] === 'telefone_contato (int)' &&
      header[5] === 'endereco (string)' &&
      header[6] === 'data_expiracao_toxocologico (dd/mm/yyyy)' &&
      header[7] === 'ativo (0,1)*' &&
      header[8] === 'cpf (int)'
    )
  }

  const _convertExcelDateToFormat = excelDate => {
    // Se for string, retorna como está
    if (typeof excelDate === 'string') {
      return excelDate
    }
    if (typeof excelDate === 'number') {
      const excelEpoch = new Date(1899, 11, 30)
      const milliseconds = excelEpoch.getTime() + excelDate * 86400000
      const date = new Date(milliseconds)

      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()

      return `${day}/${month}/${year}`
    }

    return null
  }

  const _parseDateSafely = dateStr => {
    if (!dateStr) return null

    try {
      const parsedDate = formatDateToLocale(dateStr, 'dd/MM/yyyy')
      if (parsedDate && parsedDate.isValid) {
        return parsedDate.toFormat('yyyy-MM-dd')
      }
      return null
    } catch (error) {
      return null
    }
  }

  const _buildMotoristas = content => {
    const body = content.slice(1)
    const result = []
    for (let index = 0; index < body.length; index++) {
      const row = body[index]

      if (!row[0] || (row[7] !== 0 && row[7] !== 1)) {
        throw new Error(`Erro próximo a linha ${index + 2} da planilha. Conteúdo inconsistente.`)
      }

      // Converte datas do Excel para formato correto
      const cnhExpirationStr = _convertExcelDateToFormat(row[3])
      const toxoExpirationStr = _convertExcelDateToFormat(row[6])

      result.push({
        tp_id: selectedTp,
        name: row[0].trim(),
        cnh_number: row[1] ? String(row[1]).replace(/\D/g, '') : null,
        cnh_type: row[2] ? String(row[2]).trim() : null,
        cnh_expiration: _parseDateSafely(cnhExpirationStr),
        phone: row[4] ? String(row[4]).replace(/\D/g, '') : null,
        address: row[5] ? String(row[5]).trim() : null,
        toxicologico_expiration: _parseDateSafely(toxoExpirationStr),
        actived: row[7],
        cpf: row[8] ? String(row[8]).replace(/\D/g, '') : null,
      })
    }
    return result
  }

  const onFileImported = content => {
    try {
      const isPlanilhaNoPadrao = _planilhaNoPadrao(content)
      if (!isPlanilhaNoPadrao) {
        throw new Error('Planilha Fora do Padrão. Baixe o Modelo e Verifique.')
      }
      setMotoristas(_buildMotoristas(content))
    } catch (error) {
      dispatch(showMessageBox(null, error.message))
    }
  }

  useEffect(() => {
    if (selectedTp === 0) {
      dispatch(showMessageBox(null, 'Selecione um TP'))
    } else if (motoristas.length > 0) {
      setMotoristas(prevState => {
        return prevState.map(motorista => {
          return { ...motorista, tp_id: selectedTp }
        })
      })
    }
  }, [selectedTp])

  return (
    <div>
      <PageHeader>
        <span>S.21 - Importação de Motoristas em Massa</span>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <Panel>
          <div className="p-grid">
            <div className="p-col-9" style={{ paddingTop: 35 }}>
              <div style={{ display: 'inline-block', marginLeft: 10 }}>
                <ExcelModeloBuilder
                  modeloColunas={modeloExcel}
                  filename="ImportacaoMotoristas.xlsx"
                />
              </div>
              <div style={{ display: 'inline-block', marginLeft: 10 }}>
                <ImportExcelFile
                  label="Importar"
                  classes="btnImportar"
                  onFileImported={onFileImported}
                />
              </div>

              <div style={{ display: 'inline-block', marginLeft: 10 }}>
                <Btn onClick={onBtnSalvarClicked} disabled={!selectedTp}>
                  Salvar
                </Btn>
              </div>
              <div style={{ display: 'inline-block', marginLeft: 10 }}>
                <TextBtn onClick={onBtnVoltarClicked}>Voltar</TextBtn>
              </div>
            </div>
          </div>
          <div>
            <DataTable value={motoristas}>
              <Column field="name" header="Motorista" />
              <Column field="cnh_number" header="Número CNH" style={tableCellCentered()} />
              <Column field="cnh_type" header="Categoria CNH" style={tableCellCentered()} />
              <Column
                field="cnh_expiration"
                header="Expiração CNH"
                body={item =>
                  item.cnh_expiration &&
                  formatIsoDateToLocale(item.cnh_expiration).toFormat('dd/MM/yyyy')
                }
              />
              <Column
                field="toxicologico_expiration"
                header="Expiração Toxológico"
                body={item =>
                  item.toxicologico_expiration &&
                  formatIsoDateToLocale(item.toxicologico_expiration).toFormat('dd/MM/yyyy')
                }
              />
              <Column field="phone" header="Telefone" />
              <Column
                field="actived"
                style={tableCellCentered()}
                header="Ativo"
                body={motorista => <CustomCheckbox disabled checked={!!motorista.actived} />}
              />
              <Column field="cpf" header="CPF" body={item => <CnpjCpf>{item.cpf}</CnpjCpf>} />
            </DataTable>
          </div>
        </Panel>
      </div>
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(ImportMotoristaMassa))
